import { render, staticRenderFns } from "./ns-notice.vue?vue&type=template&id=60993de2&"
import script from "./ns-notice.vue?vue&type=script&lang=js&"
export * from "./ns-notice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports